'use client';

import { useLocale, useTranslations } from 'next-intl';

import { TrackedAnchor } from '@/components/ancher';
import { TrackedButton } from '@/components/button';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { useInquiryChat } from '@/components/channel-talk';

import type { Step } from './steps';

// 스텝 CTA — 링크형(href)은 TrackedAnchor(상대경로·새 탭), 문의형(step4)은 채널톡 상담을 연다.
// 데스크탑/모바일이 className 만 달리해 공유한다.
export function StepCta({
  step,
  className,
}: {
  step: Step;
  className: string;
}) {
  const t = useTranslations('Products.process');
  const locale = useLocale();
  const inquiryChatProps = useInquiryChat();
  const label = t(`cta.${step.key}`);
  // href: 문자열=공통 경로, 객체=로케일별 경로. 모두 자사 내부 경로 → 새 탭 + noopener(referrer 보존).
  const href = typeof step.href === 'string' ? step.href : step.href?.[locale];

  if (href) {
    return (
      <TrackedAnchor
        href={href}
        label={step.trackLabel}
        position={TRACKED_EVENT_POSITION.MAIN_CONTENT}
        target="_blank"
        rel="noopener"
        className={className}
      >
        {label}
      </TrackedAnchor>
    );
  }

  return (
    <TrackedButton
      label={step.trackLabel}
      position={TRACKED_EVENT_POSITION.MAIN_CONTENT}
      {...inquiryChatProps}
      className={className}
    >
      {label}
    </TrackedButton>
  );
}
